
import React from 'react';
import Navbar from '@/components/navbar';
import Footer from '@/components/Footer';
import { Separator } from '@/components/ui/separator';

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-grow pt-24 pb-20">
        <div className="container px-4 mx-auto">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-3">1. Introduction & Agreement to Terms</h2>
              <p className="text-muted-foreground mb-4">
                Welcome to Dropify. By using our platform, you agree to comply with these Terms of Service. 
                If you do not agree with these terms, you may not use Dropify.
              </p>
            </section>
            
            <Separator className="my-6" />
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-3">2. How Dropify Works</h2>
              <p className="text-muted-foreground mb-4">
                Dropify allows artists to distribute music and provide downloads in exchange for Spotify likes. 
                However, due to Spotify's API limitations, we do not track actual likes. Instead, 
                we rely on the good faith of users to like the track before downloading.
              </p>
            </section>
            
            <Separator className="my-6" />
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-3">3. Spotify Like Policy Disclaimer</h2>
              <ul className="list-disc pl-5 space-y-2 text-muted-foreground mb-4">
                <li>
                  Dropify does NOT verify Spotify likes, as this would violate Spotify's Terms of Service.
                </li>
                <li>
                  The "Verifying Like" message is a 10-second placeholder animation to simulate verification, 
                  but no actual checking occurs.
                </li>
                <li>
                  Users are expected to like the track voluntarily before downloading.
                </li>
              </ul>
              <p className="text-amber-500 font-medium mb-4">
                ⚠️ Failure to comply with Spotify's terms could put your account at risk. 
                Dropify is not responsible for any actions taken by Spotify against your account.
              </p>
            </section>
            
            <Separator className="my-6" />
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-3">4. User Responsibilities</h2>
              <p className="text-muted-foreground mb-2">By using Dropify, you agree to:</p>
              <ul className="list-disc pl-5 space-y-2 text-muted-foreground mb-4">
                <li>Like tracks voluntarily before downloading.</li>
                <li>Not engage in fraudulent activities, such as fake likes or bots.</li>
                <li>Comply with Spotify's Terms of Service.</li>
              </ul>
            </section>
            
            <Separator className="my-6" />
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-3">5. Prohibited Conduct & Compliance</h2>
              <p className="text-muted-foreground mb-2">Users MUST NOT:</p>
              <ul className="list-disc pl-5 space-y-2 text-muted-foreground mb-4">
                <li>
                  <span className="text-red-500">🚫</span> Use automated tools, scripts, 
                  or bots to interact with Spotify.
                </li>
                <li>
                  <span className="text-red-500">🚫</span> Attempt to bypass the verification 
                  process in a deceptive way.
                </li>
                <li>
                  <span className="text-red-500">🚫</span> Engage in any action that violates 
                  Spotify's API terms.
                </li>
              </ul>
              <p className="text-muted-foreground mb-4">
                Dropify is designed to protect your account by ensuring we do not interfere 
                with Spotify's backend data.
              </p>
            </section>
            
            <Separator className="my-6" />
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-3">6. Account Termination & Liability</h2>
              <p className="text-muted-foreground mb-2">Dropify reserves the right to:</p>
              <ul className="list-disc pl-5 space-y-2 text-muted-foreground mb-4">
                <li>
                  <span className="text-green-500">✅</span> Suspend or terminate accounts 
                  that engage in fraudulent behavior.
                </li>
                <li>
                  <span className="text-green-500">✅</span> Refuse access to users who attempt 
                  to manipulate the platform.
                </li>
                <li>
                  <span className="text-green-500">✅</span> Not be held liable for any account 
                  restrictions imposed by Spotify due to misuse.
                </li>
              </ul>
            </section>
            
            <Separator className="my-6" />
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-3">7. Changes to These Terms</h2>
              <p className="text-muted-foreground mb-4">
                Dropify may update these Terms of Service periodically. 
                Users will be notified of any significant changes.
              </p>
            </section>
            
            <Separator className="my-6" />
            
            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-3">8. Contact Information</h2>
              <p className="text-muted-foreground mb-4">
                For any questions regarding these Terms of Service, please contact us at:<br />
                <span className="text-primary">📧 support@dropify.com</span>
              </p>
            </section>
            
            <div className="mt-10 pt-6 border-t border-border">
              <p className="text-sm text-muted-foreground">
                Last updated: {new Date().toLocaleDateString()}
              </p>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default TermsOfService;
